import { Notification } from "element-ui";
import $http from "../../../axios";

export async function getCashReceiptsApp({ commit }, params) {
    await $http
        .get("/api/cash-receipts-app", { params })
        .then(response => {
            commit("setData", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function getCashReceiptsAppDetail({ commit }, params) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .get("/api/cash-receipts-app-detail", { params })
            .then(async response => {
                resolve(response.data.data);
            })
            .catch(error => {
                console.error(error);
                Notification.error({
                    title: "¡Error!",
                    message: "Error al Actualizar el documento.",
                    type: "error",
                    duration: 1500,
                    customClass: "notification-box"
                });
                reject(error.response.data);
            });
    });
}

export async function getPaymentMethods({ commit }) {
    await $http
        .get("/api/parametros-por-codigo/070")
        .then(response => {
            commit("setPaymentMethods", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function getBanks({ commit }) {
    await $http
        .get("/api/parametros-por-codigo/203")
        .then(response => {
            commit("setBanks", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/cash-receipts-app/actions.js